import React, { useState, useEffect } from 'react';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';

import SelectPrivilege from '../../../UI/formulaire/SelectPrivilege/SelectPrivilege';
import ListePrivilegesDetaillees from '../../../UI/ListePrivilegesDetaillees/ListePrivilegesDetaillees';
import { connect } from 'react-redux';
import styles from './FormulairePersonalisationPrivileges.module.scss';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
function arrayEquals(a, b) {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index])
  );
}

const FormulairePersonalisationPrivileges = (props) => {
  const [personnaliserPrivilegeBool, setPersonnaliserPrivilegeBool] =
    useState(false);
  const [listePrivilegesIdCategorie, setListePrivilegesIdCategorie] = useState(
    props.preconfigurerPrivilege
  );
  const [privilegePersonnalise, setPrivilegePersonnalise] = useState([]);

  const { gererPrivilegesList } = props;

  useEffect(() => {
    gererPrivilegesList(
      personnaliserPrivilegeBool
        ? privilegePersonnalise
        : listePrivilegesIdCategorie
    );
  }, [
    personnaliserPrivilegeBool,
    privilegePersonnalise,
    listePrivilegesIdCategorie,
    gererPrivilegesList,
  ]);

  const AffichageListePrivilegesDetaillees = (
    <ListePrivilegesDetaillees
      defaultChecked={listePrivilegesIdCategorie}
      remontePrivilegePersonnalise={(listePrivilegesPersonnalise) =>
        setPrivilegePersonnalise(listePrivilegesPersonnalise)
      }
    />
  );
  return (
    <>
      <label className={styles.text}>{checkMot('privilege_utilisateur')}</label>
      <div className={[styles.text2].join(' ')}>
        {/*Affichage du label en fonction de la sélection des privilèges de l'utilisateur*/}
        <label className={s.mr_sm_2} htmlFor="inlineFormCustomSelect">
          {props.listePrivilegesParCategorie !== null &&
          props.listePrivilegesParCategorie !== undefined
            ? Object.keys(props.listePrivilegesParCategorie).map((cleCat) => {
                return !personnaliserPrivilegeBool ? (
                  arrayEquals(
                    props.listePrivilegesParCategorie[cleCat],
                    listePrivilegesIdCategorie
                  ) ? (
                    <span key={'affichage' + cleCat}>: {checkMot(cleCat)}</span>
                  ) : null
                ) : null;
              })
            : null}
        </label>
        <div className={[s.text_left].join(' ')}>
          <SelectPrivilege
            gererPrivilege={(listePrivilegesPersonnalise) =>
              setListePrivilegesIdCategorie(listePrivilegesPersonnalise)
            }
            preconfigurerPrivilege={props.preconfigurerPrivilege}
            desactive={personnaliserPrivilegeBool}
            idPrivilegeUtilisateur={props.idPrivilegeUtilisateur}
            listePrivilegesParCategorie={props.listePrivilegesParCategorie}
          />
        </div>
        {/*todo: Affichage de la liste des privilèges avec description pour la sélection personnalisé de privilège*/}
        <div className={[s.col_auto].join(' ')}>
          {checkMot('defaut')}
          <input
            type={'checkbox'}
            checked={personnaliserPrivilegeBool}
            onChange={(event) =>
              setPersonnaliserPrivilegeBool(event.target.checked)
            }
            name="personnaliserPrivilegeBool"
            key="personnaliserPrivilegeBool"
          />
          {checkMot('personnalise')}
        </div>
        <div className={[s.col_auto].join(' ')}>
          {personnaliserPrivilegeBool
            ? AffichageListePrivilegesDetaillees
            : null}
        </div>
      </div>
      {/**Privilège**/}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    idPrivilegeUtilisateur: state.authentifie.idPrivilegeUtilisateur,
    listePrivilegesParCategorie:
      state.privilegeUtilisateur.ListePrivilegesParCategorie,
  };
};
export default connect(mapStateToProps)(FormulairePersonalisationPrivileges);
